<template>
	<div>
		<ReBranchTree :tree-data="masBranch[0]" />
	</div>
</template>

<script>
	import ReBranchTree from 'src/our_components/BranchTree/ReBranchTree.vue';
	export default {
		name: 'ReBranchPrint',
		components: {
			ReBranchTree
		},
		props: {
			masBranch: Array,
		},
		data () {
			return {
				ver: 1,
			}
		},
		computed: {
		},
		methods: {
			getObjBranchBoiled(lvl,obj){
				const objRet = obj;
				if(this.masBranch.length>0 && (lvl < this.masBranch.length)){
					objRet.children = [];
					objRet.children.push(this.getObjBranchBoiled(lvl+1,this.masBranch[lvl+1]));
				}
				return objRet;
			}
		},
	}
</script>
<style scoped>

</style>
